<template>
  <div
    class="flex flex-column aside justify-content-between"
    :class="{
      'toggle-menu-active': toggleMenu,
      'toggle-menu-inactive': !toggleMenu,
    }"
  >
    <PanelMenu
      ref="menuPanel"
      :exact="true"
      :model="items"
      v-model:expandedKeys="expandedKeys"
      class="w-full"
    />
    <SelectCompany
      id="select-company"
      :class="'xlg:hidden inline-flex dropdown w-5 w-6'"
      v-if="showCompanySelect"
    >
    </SelectCompany>
    <div
      class="md:hidden bg-white w-min mb-3 mt-3 border-round-xs p-1"
      v-if="company?.logoUrl"
    >
      <img
        v-show="company?.logoUrl"
        alt="company-logo"
        :src="company?.logoUrl"
        height="40"
        @click="router.push('/home')"
        class="cursor-pointer border-round-xs"
        id="company-logo"
        v-tooltip.bottom="company?.code + ' - ' + company?.name"
      />
    </div>
    <footer>
      <p class="text-200 text-sm font-light">{{ year }} ©APS Autogestión</p>
    </footer>
  </div>
</template>

<script lang="ts" setup>
  import { computed, onMounted, ref } from 'vue'
  import { ObservableService } from '../services'
  import { useUserStore } from '@/store'
  import { storeToRefs } from 'pinia'
  import SelectCompany from './SelectCompany.vue'
  import { useRouter } from 'vue-router'

  const obsService = ObservableService.getInstance()
  const toggleMenu = ref(true)
  const expandedKeys: any = ref({})
  const userStore = useUserStore()
  const { user, company } = storeToRefs(userStore)
  const items = ref()
  const router = useRouter()
  const year = new Date().getFullYear()

  onMounted(async () => {
    obsService.getObservable('toggle-menu')?.subscribe((value) => {
      if (value !== undefined && value !== null) toggleMenu.value = value
    })
    items.value = user.value?.modules || []
    expandAll()
  })

  const expandNode = (node: any) => {
    if (node.items && node.items.length) {
      expandedKeys.value[node.key] = true

      for (let child of node.items) {
        expandNode(child)
      }
    }
  }

  const expandAll = () => {
    for (let node of items.value) {
      expandNode(node)
    }
    expandedKeys.value = { ...expandedKeys.value }
  }

  const showCompanySelect = computed(
    () =>
      user.value?.roles.name === 'admin' ||
      user.value?.roles.name === 'superadmin'
  )
</script>

<style scoped>
  .aside {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    height: calc(100vh - 40px - 1rem);
    background-color: #2d3349;
    padding: 2rem 10px 10px 10px;
    font-weight: 500;
    font-size: 14px;
    overflow-x: hidden;
  }

  @media (min-width: 1200px) {
    #select-company {
      display: none !important;
    }
  }

  @media (max-width: 1200px) {
    #select-company {
      width: 100% !important;
      display: block;
    }
  }

  :deep(.p-menuitem .p-menuitem-text) {
    color: #2563eb !important;
    font-weight: 600;
    font-size: 14px;
  }

  @media (min-width: 800px) {
    #company-logo {
      display: none;
    }
  }

  @media (max-width: 800px) {
    #company-logo {
      display: block;
      mix-blend-mode: multiply;
    }

    .aside {
      position: fixed;
      z-index: 98;
      padding-right: 10px;
      width: 300px;
      box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.08),
        0px 22px 30px 2px rgba(0, 0, 0, 0.15), 0px 8px 10px rgba(0, 0, 0, 0.15);
    }

    .toggle-menu-active {
      margin-left: 0rem;
      transform: translateX(-100%);
      transition: transform 0.3s ease-in-out;
      position: fixed;
      z-index: 98;
    }

    .toggle-menu-inactive {
      transition: transform 0.3s ease-in-out;
      transform: translateX(0%);
    }
  }

  :deep(.p-dropdown-label) {
    font-weight: 600;
    color: #2563eb !important;
    white-space: nowrap !important;
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
</style>
